import React from 'react';
import Header from '../../components/ui/Header';
import BreadcrumbNavigation from './components/BreadcrumbNavigation';
import HeroSection from './components/HeroSection';
import ServiceOverview from './components/ServiceOverview';
import ServiceBreakdown from './components/ServiceBreakdown';
import ClientBenefits from './components/ClientBenefits';
import FAQSection from './components/FAQSection';
import RelatedServices from './components/RelatedServices';
import ContactSidebar from './components/ContactSidebar';

const IndividualPracticeAreaDetail = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <BreadcrumbNavigation />
      
      <main>
        <HeroSection />
        
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-4 gap-12">
            {/* Main Content */}
            <div className="lg:col-span-3 space-y-0">
              <ServiceOverview />
              <ServiceBreakdown />
              <ClientBenefits />
              <FAQSection />
            </div>
            
            {/* Sidebar */}
            <div className="lg:col-span-1">
              <div className="sticky top-24">
                <ContactSidebar />
              </div>
            </div>
          </div>
        </div>
        
        <RelatedServices />
      </main>
    </div>
  );
};

export default IndividualPracticeAreaDetail;